export default "__VITE_ASSET__MQoutglR__"